import { render, staticRenderFns } from "./checklist-section.vue?vue&type=template&id=98c64e60&"
import script from "./checklist-section.vue?vue&type=script&lang=js&"
export * from "./checklist-section.vue?vue&type=script&lang=js&"
import style0 from "./checklist-section.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports